import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* getConfigurationsList(action) {
    try {
        const configs = yield call(() =>
            hallsAPI.getConfigurationsList(action.payload.serverId)
        );

        yield put({
            type: HallsActionTypes.GET_CONFIGURATIONS_LIST_SUCCESS,
            payload: {
                configs: configs.data.results
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting configurations list.");

        yield put({
            type: HallsActionTypes.GET_CONFIGURATIONS_LIST_FAIL,
            message: e.message
        });
    }
}

export function* getConfigurationsListWatcher() {
    yield takeLatest(
        HallsActionTypes.GET_CONFIGURATIONS_LIST,
        getConfigurationsList
    );
}
